export const arrayToObject = (array: any[]) => {
  // remove properties with null & empty string values
  const changeArrayToObject = array.reduce((acc: any, obj: any) => {
    const key = Object.keys(obj)[0];
    acc[key] = Object.values(obj)[0];
    return acc;
  }, {});

  return changeArrayToObject;
};
